export default __webpack_public_path__ + "static/media/tues-blue.b04c79a5.png";